import BSWholeWheatBagelsProduct from 'models/BSWholeWheatBagelsProduct'

export const packagingInitialState = {
  category: BSWholeWheatBagelsProduct.category,
  subCategory: BSWholeWheatBagelsProduct.subCategory,
  Size: BSWholeWheatBagelsProduct.Size,
}
